import interfaceApi from '@/api/admin/interfaceApi'
import { queryKeys } from '@/constant/common'
import { IInterfaceByIdResponse } from '@/types/interface'
import { useQuery } from '@tanstack/react-query'

function useSearchInterfaceId(id?: string) {
  return useQuery<IInterfaceByIdResponse | null>(
    [queryKeys.interface, id],
    async () => {
      if (!id || id === 'null' || id === 'undefined') {
        return null
      }
      const { data } = await interfaceApi.getById(id)

      if (!data) return null
      return {
        id: data.id,
        name: data.name,
        organizationId: data.organizationId,
        weatherLinkStations: data.weatherLinkStations,
        updatedAt: data?.updatedAt || '',
        pictureFileName: data.pictureFileName || '',
        pictureUrl: data.pictureUrl || '',
        timeZoneId: data.timeZoneId || '',
        timeZoneOriginId: data.timeZoneOriginId || '',
        customName: data.customName || '',
        state: data.state || '',
        countryId: data.countryId || '',
        countryName: data.countryName || '',
        isObservedDst: data.isObservedDst || false,
        timeZone: data.timeZone || '',
        type: data.type || '',
        timeZoneName: data.timeZoneName || '',
        status: data.status ?? false,
        softWareVersion: data.softWareVersion ?? 0,
      }
    },
  )
}

export default useSearchInterfaceId
